export const pianoKeys = [
  { name: 'A0 - First tone', frequency: 27.5 },
  { name: 'A#0/Bb0', frequency: 29.1353 },
  { name: 'B0', frequency: 30.8677 },
  { name: 'C1', frequency: 32.7032 },
  { name: 'C#1/Db1', frequency: 34.6479 },
  { name: 'D1', frequency: 36.7081 },
  { name: 'D#1/Eb1', frequency: 38.8909 },
  { name: 'E1', frequency: 41.2035 },
  { name: 'F1', frequency: 43.6536 },
  { name: 'F#1/Gb1', frequency: 46.2493 },
  { name: 'G1', frequency: 48.9995 },
  { name: 'G#1/Ab1', frequency: 51.913 },
  { name: 'A1', frequency: 55 },
  { name: 'A#1/Bb1', frequency: 58.2705 },
  { name: 'B1', frequency: 61.7354 },
  { name: 'C2 (low C)', frequency: 65.4064 },
  { name: 'C#2/Db2', frequency: 69.2957 },
  { name: 'D2', frequency: 73.4162 },
  { name: 'D#2/Eb2', frequency: 77.7817 },
  { name: 'E2', frequency: 82.4069 },
  { name: 'F2', frequency: 87.3071 },
  { name: 'F#2/Gb2', frequency: 92.4986 },
  { name: 'G2', frequency: 97.9989 },
  { name: 'G#2/Ab2', frequency: 103.826 },
  { name: 'A2', frequency: 110 },
  { name: 'A#2/Bb2', frequency: 116.541 },
  { name: 'B2', frequency: 123.471 },
  { name: 'C3', frequency: 130.813 },
  { name: 'C#3/Db3', frequency: 138.591 },
  { name: 'D3', frequency: 146.832 },
  { name: 'D#3/Eb3', frequency: 155.563 },
  { name: 'E3', frequency: 164.814 },
  { name: 'F3', frequency: 174.614 },
  { name: 'F#3/Gb3', frequency: 184.997 },
  { name: 'G3', frequency: 195.998 },
  { name: 'G#3/Ab3', frequency: 207.652 },
  { name: 'A3', frequency: 220 },
  { name: 'A#3/Bb3', frequency: 233.082 },
  { name: 'B3', frequency: 246.942 },
  { name: 'C4 (middle C)', frequency: 261.626 },
  { name: 'C#4/Db4', frequency: 277.183 },
  { name: 'D4', frequency: 293.665 },
  { name: 'D#4/Eb4', frequency: 311.127 },
  { name: 'E4', frequency: 329.628 },
  { name: 'F4', frequency: 349.228 },
  { name: 'F#4/Gb4', frequency: 369.994 },
  { name: 'G4', frequency: 391.995 },
  { name: 'G#4/Ab4', frequency: 415.305 },
  { name: 'A4 concert pitch', frequency: 440 },
  { name: 'A#4/Bb4', frequency: 466.164 },
  { name: 'B4', frequency: 493.883 },
  { name: 'C5', frequency: 523.251 },
  { name: 'C#5/Db5', frequency: 554.365 },
  { name: 'D5', frequency: 587.33 },
  { name: 'D#5/Eb5', frequency: 622.254 },
  { name: 'E5', frequency: 659.255 },
  { name: 'F5', frequency: 698.456 },
  { name: 'F#5/Gb5', frequency: 739.989 },
  { name: 'G5', frequency: 783.991 },
  { name: 'G#5/Ab5', frequency: 830.609 },
  { name: 'A5', frequency: 880 },
  { name: 'A#5/Bb5', frequency: 932.328 },
  { name: 'B5', frequency: 987.767 },
  { name: 'C6 (high C)', frequency: 1046.5 },
  { name: 'C#6/Db6', frequency: 1108.73 },
  { name: 'D6', frequency: 1174.66 },
  { name: 'D#6/Eb6', frequency: 1244.51 },
  { name: 'E6', frequency: 1318.51 },
  { name: 'F6', frequency: 1396.91 },
  { name: 'F#6/Gb6', frequency: 1479.98 },
  { name: 'G6', frequency: 1567.98 },
  { name: 'G#6/Ab6', frequency: 1661.22 },
  { name: 'A6', frequency: 1760 },
  { name: 'A#6/Bb6', frequency: 1864.66 },
  { name: 'B6', frequency: 1975.53 },
  { name: 'C7', frequency: 2093 },
  { name: 'C#7/Db7', frequency: 2217.46 },
  { name: 'D7', frequency: 2349.32 },
  { name: 'D#7/Eb7', frequency: 2489.02 },
  { name: 'E7', frequency: 2637.02 },
  { name: 'F7', frequency: 2793.83 },
  { name: 'F#7/Gb7', frequency: 2959.96 },
  { name: 'G7', frequency: 3135.96 },
  { name: 'G#7/Ab7', frequency: 3322.44 },
  { name: 'A7', frequency: 3520 },
  { name: 'A#7/Bb7', frequency: 3729.31 },
  { name: 'B7', frequency: 3951.07 },
  { name: 'C8 - Last tone', frequency: 4186.01 },
]
